
export default {
  namespaced: true,
  state: {
    loading: false,
    errorLoading: true,
    catalogues: []
  },
  actions: {
    loadCatalogues({ commit, rootGetters }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR_LOADING', false)

      return rootGetters.getGraphQLClient('thesaurum').query({
        query: `
          query {
            catalogues(prefix: "product-catalogues--") {
              contentid
              content
            }
          }
        `
      })
        .then((results) => {
          if (Object.prototype.hasOwnProperty.call(results, 'errors')) {
            results.errors.map((error) => console.error(error.message))
            commit('SET_ERROR_LOADING', true)
          }
          else if (Object.prototype.hasOwnProperty.call(results, 'data')) {
            const catalogues = (results && results.data && results.data.catalogues)
              ? results.data.catalogues.reduce((acc, item) => {
                const catalogeContent = JSON.parse(item.content)
                acc[catalogeContent.uuid] = catalogeContent
                return acc
              }, {})
              : {}
            commit('SET_CATALOGUES', catalogues)
          }

          return results
        })
        .catch((error) => {
          console.error(error.message)
          commit('SET_ERROR_LOADING', true)
        })
        .finally(() => commit('SET_LOADING', false))
    },
    saveCatalogue(context, payload) {
    }
  },
  mutations: {
    SET_LOADING(state, payload) { state.loading = payload },
    SET_ERROR_LOADING(state, payload) { state.errorLoading = payload },
    SET_CATALOGUES(state, payload) { state.catalogues = payload }
  },
  getters: {
    all: (state) => state.catalogues,
    getSingleCatalogue: (state) => (id) => {
      return state.catalogues[id] ?? {}
    },
    isActive: (state) => (id) => {
      return state.catalogues[id]?.active ?? false
    },
    products: (state, getters, rootState, rootGetters) => rootGetters['products/all'],
    loading: (state) => state.loading,
    errorLoading: (state) => state.errorLoading
  }
}
